import type { AttributeType, DishAttrType, DishAttributesType } from '../../../types/product';
import { AttributesWrapper, Price, Title, Wrapper } from './AttributeSelector.styled';

import { Attribute } from './Attribute';
import { useTranslation } from 'next-i18next';

interface Props {
  attributesList: DishAttributesType;
  currencySymbol: string;
  attribute: string;
  dishAttributes: DishAttrType;
  setDishAttributes: (attr: DishAttrType) => void;
  setHardReset: (value: boolean) => void;
}


export const AttributeSelector = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <Wrapper>
        <Title>{t(`DishAttributes.${props.attribute}.title`)}</Title>
        {props.attributesList[props.attribute]?.max > 1 ? (
          <Price>
            {t('DishAttributes.attr.max', { max: props.attributesList[props.attribute]?.max })}
          </Price>
        ) : null}
        {props.attributesList[props.attribute]?.mandatory === 'true' ? (
          <Price>
            <span>
              {t('DishAttributes.mustSelectAttr.tag')}
            </span>
          </Price>
        ) : null}
      </Wrapper>
      <AttributesWrapper>
        {props.attributesList[props.attribute]?.elements.map((elem: AttributeType) => (
          <Attribute
            key={elem.name}
            {...elem}
            setDishAttributes={props.setDishAttributes}
            dishAttributes={props.dishAttributes}
            currencySymbol={props.currencySymbol}
            attribute={props.attribute}
            type={props.attributesList[props.attribute]?.type}
            max={props.attributesList[props.attribute]?.max}
            setHardReset={props.setHardReset}
          />
        ))}
      </AttributesWrapper>
    </div>
  );
};
